import { FieldOptions } from '../index';
import { EasyField } from '../baseClasses/easyField';

export class EasyToolbarTextField extends EasyField {
    controlType = 'toolbar-text';
    color: string;
    icon: string;
    type: string;

    constructor(options: FieldOptions<any> = {}) {
        super(options);
        this.color = options.color || '';
        this.icon = options.icon || '';
    }
}
